import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FixturesComponent } from '../fixtures/fixtures.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forChild([
            {path: 'fixtures', component: FixturesComponent, data: {breadcrumb: 'Fixtures'}}
        ])
    ],
    declarations: []
})
export class FixturesModule { }